import { Navigate, Outlet, useLocation, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { crmBranchesPath, parseCrmBranchIdFromPath } from '@crm/crmPaths';
import { AppShellBrand } from '@shared/components/AppShellBrand';
import { ThemeToggle } from '@shared/components/ThemeToggle';

import { CrmBranchHeader } from './CrmBranchHeader';

const OWNER_UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Если в URL чужой ownerId, перенаправляем на канонический из JWT. */
function CrmOwnerMatch() {
  const { ownerId } = useParams();
  const profile = useSelector((s) => s.crmAuth.profile);
  const { status, sessionChecked } = useSelector((s) => s.crmAuth);

  if (!sessionChecked || status !== 'authenticated' || !ownerId) return null;
  if (!profile?.ownerId) return null;
  if (profile.ownerId !== ownerId) {
    return <Navigate to={crmBranchesPath(profile.ownerId)} replace />;
  }
  return null;
}

export function CrmLayout() {
  const { ownerId } = useParams();
  const { pathname } = useLocation();
  if (!ownerId || !OWNER_UUID_RE.test(ownerId)) {
    return <Navigate to="/" replace />;
  }

  const branchId = parseCrmBranchIdFromPath(pathname, ownerId);
  const isBranchContext = Boolean(branchId);

  const headerClass = [
    'app-shell__header',
    'app-shell__header--crm',
    isBranchContext && 'app-shell__header--crm-branch',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className="app-shell app-shell--crm">
      <header className={headerClass}>
        <AppShellBrand />
        {isBranchContext ? <CrmBranchHeader /> : <ThemeToggle className="crm-header__theme" />}
      </header>
      <main className="app-shell__main">
        <CrmOwnerMatch />
        <Outlet />
      </main>
    </div>
  );
}
